export const REPORT_TYPES = [
  'management_review',
  'audit',
  'soa',
  'environmental_aspects',
  'safety_incident',
  'document_reading',
  'calibration_overdue',
] as const;

export type ReportType = (typeof REPORT_TYPES)[number];

/** Id reservado para informes de alcance organizacional (SoA, matriz de aspectos). */
export const ORG_WIDE_REPORT_RESOURCE_ID = 'export';
